import { createApiInstance } from "./InstanceAPI";

export const addRegister = async (registration) => {
  const api = createApiInstance();
  const { data } = await api.post("/users/signin", {
    registration: [registration],
  });
  return data;
};
export const addRoutine = async (routine) => {
  const api = createApiInstance();
  const { data } = await api.post("/integrantes/new", routine);
  return data;
};
export const editRoutine = async (routine) => {
  const api = createApiInstance();
  const { data } = await api.post("/integrantes/edit", routine);
  return data;
};
export const getAppStudents = async () => {
  const api = createApiInstance();
  const { data } = await api.get("/users");
  return data.users.filter((item) => {
    if (item.type === "STUDENT") {
      return item;
    }
    return null;
  });
};
export const getAccessData = async (register) => {
  try {

    if (!register) {
      throw new Error("Registro não pode ser vazio");
    }

    const api = createApiInstance();
    const response = await api.post("/users/info", { registration: register });

    return response.data;
  } catch (error) {
    throw error;
  }
};
export const getAllTokens = async () => {
  const api = createApiInstance();
  const { data } = await api.get("/users");
  return data.users.filter((item) => {
    if (item.tokenNotification !== null) {
      return item;
    }
    return null;
  });
};
export const getAppResponsables = async () => {
  const api = createApiInstance();
  const { data } = await api.get("/users");
  return data.users.filter((item) => {
    if (item.type === "RESPONSABLE") {
      return item;
    }
    return null;
  });
};
export const sendResponsableNotification = async (notification) => {
  const api = createApiInstance();
  const { data } = await api.post("/notifications/send", notification);
  return data;
};
export const sendAnnouncements = async (announcements, type) => {
  const api = createApiInstance();
  if (type === "TEXT") {
    const { data } = await api.post("/announcements/send", announcements);
    return data;
  } else {
    const { data } = await api.post("/announcements/upload", announcements);
    return data;
  }
};
export const getAllNotifications = async () => {
  const api = createApiInstance();
  const { data } = await api.get("/notifications/list");
  return data;
};
export const getAllAnnouncements = async () => {
  const api = createApiInstance();
  const { data } = await api.get("/announcements/list");
  return data;
};
export const getInfoTeacher = async (id) => {
  const api = createApiInstance();
  const { data } = await api.post("/teachers/one", { id });
  return data;
};
export const getSubjectsByTeacher = async (teacher_id, classroom_id) => {
  const api = createApiInstance();
  const { data } = await api.post("/classes/one", { teacher_id, classroom_id });
  return data;
};
export const addActivity = async (activity) => {
  const api = createApiInstance();
  const { data } = await api.post("/activities/new", activity);
  return data;
};
export const sendDiary = async (diary) => {
  const api = createApiInstance();
  const { data } = await api.delete("/diaries/new", diary);
  return data;
};
export const deleteDiary = async (diaryId) => {
  const api = createApiInstance();
  const { data } = await api.delete("/diaries/delete", {
    data: { id: diaryId },
  });
  return data;
};
export const sendGraphDiary = async (diary, type) => {
  const api = createApiInstance();
  if (type === "TEXT") {
    const { data } = await api.post("/diaries/send", diary);
    return data;
  } else {
    const { data } = await api.post("/diaries/upload", diary);
    return data;
  }
};
export const sendOneSignalAnnouncements = async (form) => {
  const api = createApiInstance();
  const { data } = await api.post("/announcements/upload", form);
  return data;
};
// Novo endpoint para upload em lote de comunicados
export const sendOneSignalAnnouncementsBulk = async (form) => {
  const api = createApiInstance();
  const { data } = await api.post("/announcements/upload/bulk", form);
  return data;
};
export const getDiariesByDate = async (date) => {
  const api = createApiInstance();
  const { data } = await api.post("/diaries/date", { date });
  return data;
};
export const getGradesByClassroom = async (TurmaID, DisciplinaID, period) => {
  if (!period) {
    return { grades: [] };
  }
  
  const api = createApiInstance();
  
  try {
    // Garantir que period seja string (backend espera string)
    const periodString = period ? String(period) : period;
    // Garantir que DisciplinaID seja número (backend espera integer positivo)
    const disciplinaIdNum = DisciplinaID ? Number(DisciplinaID) : null;
    // Garantir que TurmaID seja número ou string válido
    const turmaIdNum = TurmaID ? (typeof TurmaID === 'string' ? parseInt(TurmaID, 10) : Number(TurmaID)) : null;
    
    if (!disciplinaIdNum || isNaN(disciplinaIdNum) || disciplinaIdNum <= 0) {
      return { grades: [] };
    }
    
    if (!turmaIdNum || isNaN(turmaIdNum) || turmaIdNum <= 0) {
      return { grades: [] };
    }
    
    const { data } = await api.post("/grades/list/classroom", {
      TurmaID: turmaIdNum,
      DisciplinaID: disciplinaIdNum,
      period: periodString,
    });
    
    // Garantir que apenas notas do período correto são retornadas
    if (data && data.grades && Array.isArray(data.grades)) {
      // Filtrar notas para garantir que apenas as do período correto sejam usadas
      data.grades = data.grades.filter(grade => {
        return String(grade.period) === String(period);
      });
    }
    
    return data;
  } catch (error) {
    return { grades: [] };
  }
};
export const updateVisibilityByStudent = async (
  AlunoID,
  TurmaID,
  DisciplinaID,
  period,
  visibility
) => {
  const api = createApiInstance();
  const maxRetries = 3;
  let attempt = 0;
  let lastError = null;
  
  while (attempt < maxRetries) {
    try {
      // Validar que AlunoID está presente e é válido
      if (!AlunoID && AlunoID !== 0) {
        throw new Error('AlunoID é obrigatório para atualizar visibilidade');
      }
      
      // Garantir que period seja string (backend espera string)
      const periodString = period ? String(period) : period;
      
      // Garantir que AlunoID seja string ou number válido
      const alunoIDNormalized = AlunoID != null ? (typeof AlunoID === 'string' ? AlunoID : String(AlunoID)) : null;
      
      if (!alunoIDNormalized) {
        throw new Error('AlunoID inválido');
      }
      
      const { data } = await api.post("/grades/new", {
        AlunoID: alunoIDNormalized,
        TurmaID,
        DisciplinaID,
        period: periodString,
        visibility,
      });
      
      // Também salvar no localStorage como fallback
      const storageKey = `visibility_${AlunoID}_${TurmaID}_${DisciplinaID}_${period}`;
      localStorage.setItem(storageKey, JSON.stringify({
        visibility,
        timestamp: new Date().toISOString()
      }));
      
      return data;
    } catch (error) {
      attempt++;
      lastError = error;
      
      if (attempt < maxRetries) {
        const waitTime = 1000 * attempt;
        await new Promise(resolve => setTimeout(resolve, waitTime));
      }
    }
  }
  
  // Usar o localStorage como fallback para persistir os dados localmente
  const storageKey = `visibility_${AlunoID}_${TurmaID}_${DisciplinaID}_${period}`;
  localStorage.setItem(storageKey, JSON.stringify({
    visibility,
    timestamp: new Date().toISOString(),
    failedSync: true
  }));
  
  throw lastError || new Error("Erro ao atualizar visibilidade após múltiplas tentativas");
};

// Nova função para recuperar visibilidade do localStorage
export const getStoredVisibility = (AlunoID, TurmaID, DisciplinaID, period) => {
  try {
    const storageKey = `visibility_${AlunoID}_${TurmaID}_${DisciplinaID}_${period}`;
    const storedData = localStorage.getItem(storageKey);
    
    if (storedData) {
      const parsedData = JSON.parse(storedData);
      return parsedData.visibility;
    }
  } catch (error) {
    // Erro silencioso ao recuperar do localStorage
  }
  
  return null; // Retorna null se não encontrar ou ocorrer um erro
};

// Função para formatar valores de notas de forma padronizada
export const formatGradeValue = (value) => {
  if (value === null || value === undefined || value === "") return "";
  
  // Converter para string caso seja um número
  const strValue = String(value).trim();
  
  // Se for uma string vazia, retorna vazia
  if (strValue === "") return "";
  
  // Se for "0" ou zero, retornar vazio (ou "0,0" dependendo do caso de uso)
  if (strValue === "0") return "";
  
  try {
    // Converter para número para garantir formato correto
    // Primeiro substituímos vírgula por ponto para tratar números brasileiros
    const numValue = parseFloat(strValue.replace(",", "."));
    
    // Verificar se é NaN
    if (isNaN(numValue)) return "";
    
    // Se for zero, retornar vazio
    if (numValue === 0) return "";
    
    // CRÍTICO: Fazer o mesmo arredondamento matemático usado no sistema Sponte
    // Math.round(x * 10) / 10 faz um arredondamento matemático para 1 casa decimal
    // Exemplo: 6.35 → 6.4, 6.34 → 6.3
    const roundedValue = Math.round(numValue * 10) / 10;
    
    // Formatar para ter sempre uma casa decimal, usando vírgula como separador
    return roundedValue.toFixed(1).replace(".", ",");
  } catch (error) {
    return "";
  }
};

// Nova função para calcular AC1 de forma consistente
export const calculateAC1 = (at1, at2) => {
  // Normalizar os valores: converter para números com ponto decimal
  const at1Value = parseFloat((at1 && at1.replace(",", ".")) || 0);
  const at2Value = parseFloat((at2 && at2.replace(",", ".")) || 0);
  
  // Se ambos forem zero, retorna string vazia
  if (at1Value === 0 && at2Value === 0) return "";
  
  // Calcular a soma
  const sum = at1Value + at2Value;
  
  // Aplicar arredondamento matemático para uma casa decimal
  const roundedSum = Math.round(sum * 10) / 10;
  
  // Formatar com 1 casa decimal e usando vírgula
  return roundedSum.toFixed(1).replace(".", ",");
};

// Função para calcular AC2 de forma consistente
export const calculateAC2 = (at3, at4, at5, at6) => {
  // Normalizar os valores: converter para números com ponto decimal
  const at3Value = parseFloat((at3 && at3.replace(",", ".")) || 0);
  const at4Value = parseFloat((at4 && at4.replace(",", ".")) || 0);
  const at5Value = parseFloat((at5 && at5.replace(",", ".")) || 0);
  const at6Value = parseFloat((at6 && at6.replace(",", ".")) || 0);
  
  // Se todos forem zero, retorna string vazia
  if (at3Value === 0 && at4Value === 0 && at5Value === 0 && at6Value === 0) return "";
  
  // Calcular a soma
  const sum = at3Value + at4Value + at5Value + at6Value;
  
  // Aplicar arredondamento matemático para uma casa decimal
  const roundedSum = Math.round(sum * 10) / 10;
  
  // Formatar com 1 casa decimal e usando vírgula
  return roundedSum.toFixed(1).replace(".", ",");
};

// Função para calcular MB de forma consistente
export const calculateMB = (ac1, ac2) => {
  // Verificar se AC1 e AC2 estão vazios
  if ((!ac1 || ac1 === "") && (!ac2 || ac2 === "")) return "";
  
  // Normalizar os valores: converter para números com ponto decimal
  const ac1Value = parseFloat((ac1 && ac1.replace(",", ".")) || 0);
  const ac2Value = parseFloat((ac2 && ac2.replace(",", ".")) || 0);
  
  // Se ambos forem zero, retorna string vazia
  if (ac1Value === 0 && ac2Value === 0) return "";
  
  // Calcular a média
  const media = (ac1Value + ac2Value) / 2;
  
  // Aplicar arredondamento matemático para uma casa decimal
  const roundedMedia = Math.round(media * 10) / 10;
  
  // Formatar com 1 casa decimal e usando vírgula
  return roundedMedia.toFixed(1).replace(".", ",");
};

// Função para verificar se um valor é convertido para número
export const isNumber = (value) => {
  if (value === null || value === undefined || value === "") return false;
  return !isNaN(parseFloat(String(value).replace(",", ".")));
};

// Função para normalizar valor para cálculos
export const normalizeValue = (value) => {
  if (!value || value === "") return 0;
  return parseFloat(String(value).replace(",", "."));
};

// Modifica a função updateGradesByStudent para criar backup automaticamente
export const updateGradesByStudent = async (
  AlunoID,
  TurmaID,
  DisciplinaID,
  period,
  at1,
  at2,
  at3,
  at4,
  at5,
  at6,
  ac1,
  ac2,
  rm,
  mb,
  nomeDisciplina,
  visibility
) => {
  // Validações defensivas completas
  if (!AlunoID || AlunoID === null || AlunoID === undefined || AlunoID === '') {
    throw new Error("AlunoID não fornecido para atualização de notas");
  }
  if (!TurmaID || TurmaID === null || TurmaID === undefined || TurmaID === '') {
    throw new Error("TurmaID não fornecido para atualização de notas");
  }
  if (!DisciplinaID || DisciplinaID === null || DisciplinaID === undefined || DisciplinaID === '') {
    throw new Error("DisciplinaID não fornecido para atualização de notas");
  }
  if (!period || period === null || period === undefined || period === '') {
    throw new Error("Período não fornecido para atualização de notas");
  }
  
  const api = createApiInstance();
  
  // Formatar todas as notas antes de enviar para o servidor
  const formattedAt1 = formatGradeValue(at1);
  const formattedAt2 = formatGradeValue(at2);
  const formattedAt3 = formatGradeValue(at3);
  const formattedAt4 = formatGradeValue(at4);
  const formattedAt5 = formatGradeValue(at5);
  const formattedAt6 = formatGradeValue(at6);
  const formattedAc1 = formatGradeValue(ac1);
  const formattedAc2 = formatGradeValue(ac2);
  const formattedRm = formatGradeValue(rm);
  const formattedMb = formatGradeValue(mb);
  
  // Implementar sistema de tentativas para maior resiliência
  const maxRetries = 3;
  let attempt = 0;
  let lastError = null;
  
  while (attempt < maxRetries) {
    try {
      // Normalizar IDs para os tipos esperados pelo backend
      // AlunoID e TurmaID devem ser strings (modelo espera STRING(5))
      const alunoIDNormalized = String(AlunoID);
      const turmaIDNormalized = TurmaID ? String(TurmaID) : undefined;
      const disciplinaIDNum = typeof DisciplinaID === 'string' ? parseInt(DisciplinaID, 10) : Number(DisciplinaID);
      const periodString = period ? String(period) : period;
      
      // Validar DisciplinaID
      if (isNaN(disciplinaIDNum) || disciplinaIDNum <= 0) {
        throw new Error(`DisciplinaID inválido: ${DisciplinaID}`);
      }
      
      const payload = {
        AlunoID: alunoIDNormalized,
        DisciplinaID: disciplinaIDNum,
        period: periodString,
        at1: formattedAt1,
        at2: formattedAt2,
        at3: formattedAt3,
        at4: formattedAt4,
        at5: formattedAt5,
        at6: formattedAt6,
        ac1: formattedAc1,
        ac2: formattedAc2,
        rm: formattedRm,
        mb: formattedMb,
        nomeDisciplina,
        visibility,
      };
      
      // TurmaID é opcional no schema, só adicionar se fornecido
      if (turmaIDNormalized) {
        payload.TurmaID = turmaIDNormalized;
      }
      
      try {
        const response = await api.post("/grades/new", payload);
        
        // Também salvar a visibilidade no localStorage
        const storageKey = `visibility_${AlunoID}_${TurmaID}_${DisciplinaID}_${period}`;
        localStorage.setItem(storageKey, JSON.stringify({
          visibility,
          timestamp: new Date().toISOString()
        }));
        
        return response.data;
      } catch (apiError) {
        // Melhorar mensagem de erro com detalhes da validação
        if (apiError.response?.status === 400) {
          const errorMessage = apiError.response?.data?.message || apiError.response?.data?.error || apiError.message;
          throw new Error(`Erro de validação ao salvar notas: ${errorMessage}`);
        }
        throw apiError;
      }
    } catch (error) {
      attempt++;
      lastError = error;
      
      // Log do erro
      // Se não for o último retry, aguarde antes de tentar novamente
      if (attempt < maxRetries) {
        const waitTime = 1000 * attempt; // Espera progressiva: 1s, 2s, 3s...
        await new Promise(resolve => setTimeout(resolve, waitTime));
      }
    }
  }
  
  // Usar o localStorage como fallback para persistir a visibilidade
  const storageKey = `visibility_${AlunoID}_${TurmaID}_${DisciplinaID}_${period}`;
  localStorage.setItem(storageKey, JSON.stringify({
    visibility,
    timestamp: new Date().toISOString(),
    failedSync: true
  }));
  
  throw lastError || new Error("Erro ao salvar notas após múltiplas tentativas");
};

// Função para atualizar todas as notas de um aluno
export const updateAllGrades = async (
  AlunoID,
  TurmaID,
  DisciplinaID,
  period,
  values
) => {
  // Verificar se o período é válido
  if (!period) {
    throw new Error("Período não definido");
  }
  
  const api = createApiInstance();
  
  // Verificar se há uma visibilidade armazenada que deve ser preservada
  let visibility;
  const storageKey = `visibility_${AlunoID}_${TurmaID}_${DisciplinaID}_${period}`;
  try {
    const storedData = localStorage.getItem(storageKey);
    if (storedData) {
      const parsedData = JSON.parse(storedData);
      visibility = parsedData.visibility;
    }
  } catch (error) {
    // Erro silencioso ao recuperar do localStorage
  }
  
  // Se tiver visibilidade armazenada, incluir nos valores
  if (visibility !== undefined && !values.hasOwnProperty('visibility')) {
    values.visibility = visibility;
  }
  
  // Formatar os valores de notas no objeto values
  // Garantir que period seja string (backend espera string)
  const periodString = period ? String(period) : period;
  const formattedValues = { ...values, period: periodString }; // Garantir que o período seja incluído como string
  
  // Formatar todos os valores de nota
  if (formattedValues.at1 !== undefined) formattedValues.at1 = formatGradeValue(formattedValues.at1);
  if (formattedValues.at2 !== undefined) formattedValues.at2 = formatGradeValue(formattedValues.at2);
  if (formattedValues.at3 !== undefined) formattedValues.at3 = formatGradeValue(formattedValues.at3);
  if (formattedValues.at4 !== undefined) formattedValues.at4 = formatGradeValue(formattedValues.at4);
  if (formattedValues.at5 !== undefined) formattedValues.at5 = formatGradeValue(formattedValues.at5);
  if (formattedValues.at6 !== undefined) formattedValues.at6 = formatGradeValue(formattedValues.at6);
  if (formattedValues.ac1 !== undefined) formattedValues.ac1 = formatGradeValue(formattedValues.ac1);
  if (formattedValues.ac2 !== undefined) formattedValues.ac2 = formatGradeValue(formattedValues.ac2);
  if (formattedValues.rm !== undefined) formattedValues.rm = formatGradeValue(formattedValues.rm);
  if (formattedValues.mb !== undefined) formattedValues.mb = formatGradeValue(formattedValues.mb);
  
  // Implementar sistema de tentativas para maior resiliência
  const maxRetries = 3;
  let attempt = 0;
  let lastError = null;
  
  while (attempt < maxRetries) {
    try {
      // Normalizar IDs para os tipos esperados pelo backend
      // AlunoID e TurmaID devem ser strings (modelo espera STRING(5))
      const alunoIDNormalized = String(AlunoID);
      const turmaIDNormalized = TurmaID ? String(TurmaID) : undefined;
      const disciplinaIDNum = typeof DisciplinaID === 'string' ? parseInt(DisciplinaID, 10) : Number(DisciplinaID);
      
      // Validar DisciplinaID
      if (isNaN(disciplinaIDNum) || disciplinaIDNum <= 0) {
        throw new Error(`DisciplinaID inválido: ${DisciplinaID}`);
      }
      
      const payload = {
        AlunoID: alunoIDNormalized,
        DisciplinaID: disciplinaIDNum,
        period: periodString,
        ...formattedValues,
      };
      
      // TurmaID é opcional no schema, só adicionar se fornecido
      if (turmaIDNormalized) {
        payload.TurmaID = turmaIDNormalized;
      }
      
      try {
        const response = await api.post("/grades/new", payload);
        
        // Se tiver visibilidade, armazenar no localStorage
        if (formattedValues.visibility !== undefined) {
          const storageKey = `visibility_${AlunoID}_${TurmaID}_${DisciplinaID}_${period}`;
          localStorage.setItem(storageKey, JSON.stringify({
            visibility: formattedValues.visibility,
            timestamp: new Date().toISOString()
          }));
        }
        
        return response.data;
      } catch (apiError) {
        // Melhorar mensagem de erro com detalhes da validação
        if (apiError.response?.status === 400) {
          const errorMessage = apiError.response?.data?.message || apiError.response?.data?.error || apiError.message;
          throw new Error(`Erro de validação ao salvar notas: ${errorMessage}`);
        }
        throw apiError;
      }
    } catch (error) {
      attempt++;
      lastError = error;
      
      // Log do erro
      // Se não for o último retry, aguarde antes de tentar novamente
      if (attempt < maxRetries) {
        const waitTime = 1000 * attempt; // Espera progressiva: 1s, 2s, 3s...
        await new Promise(resolve => setTimeout(resolve, waitTime));
      }
    }
  }
  
  // Se tiver visibilidade, salvar no localStorage como fallback
  if (formattedValues.visibility !== undefined) {
    const storageKey = `visibility_${AlunoID}_${TurmaID}_${DisciplinaID}_${period}`;
    localStorage.setItem(storageKey, JSON.stringify({
      visibility: formattedValues.visibility,
      timestamp: new Date().toISOString(),
      failedSync: true
    }));
  }
  
  throw lastError || new Error("Erro ao salvar notas após múltiplas tentativas");
};

export const setCaptions = async (captions) => {
  const api = createApiInstance();
  // Garantir que period seja string (backend espera string)
  const normalizedCaptions = {
    ...captions,
    period: captions.period ? String(captions.period) : captions.period,
  };
  const { data } = await api.post("/grades/captions", normalizedCaptions);
  return data;
};
export const getCaptions = async (TurmaID, period) => {
  const api = createApiInstance();
  // Garantir que period seja string (backend espera string)
  const periodString = period ? String(period) : period;
  const { data } = await api.post("/grades/captions/list", { TurmaID, period: periodString });
  return data;
};
export const getTeachers = async () => {
  const api = createApiInstance();
  const { data } = await api.get("/access/teachers");
  return data;
};

export const getAllAccessLevels = async () => {
  const api = createApiInstance();
  const { data } = await api.get("/access/all");
  return data;
};

export const getMenuPermissionsEditor = async (userId) => {
  const api = createApiInstance();
  const { data } = await api.get(`/access/menu-permissions/${userId}`);
  return data;
};

export const updateMenuPermissions = async (userId, menuOverrides) => {
  const api = createApiInstance();
  const { data } = await api.put("/access/menu-permissions", { userId, menuOverrides });
  return data;
};
export const getTeachersAllocations = async (
  teacherID,
  DisciplinaID = null,
  TurmaID = null
) => {
  const api = createApiInstance();
  // Garantir que teacherID seja um número
  const teacherIdNum = typeof teacherID === 'number' ? teacherID : parseInt(teacherID, 10);
  
  const requestBody = {
    teacherID: teacherIdNum,
  };
  
  // Adicionar apenas se não forem null/undefined
  if (DisciplinaID !== null && DisciplinaID !== undefined) {
    requestBody.DisciplinaID = typeof DisciplinaID === 'number' ? DisciplinaID : parseInt(DisciplinaID, 10);
  }
  
  if (TurmaID !== null && TurmaID !== undefined) {
    requestBody.TurmaID = typeof TurmaID === 'number' ? TurmaID : parseInt(TurmaID, 10);
  }
  
  const { data } = await api.post("/allocation/list", requestBody);
  return data;
};
export const allocateTeacher = async (
  teacherID,
  teacherName,
  TurmaID,
  turmaName,
  DisciplinaID,
  disciplinaName
) => {
  const api = createApiInstance();
  const { data } = await api.post("/allocation/new", {
    teacherID,
    teacherName,
    TurmaID,
    turmaName,
    DisciplinaID,
    disciplinaName,
  });
  return data;
};

export const deallocateTeacher = async (
  teacherID,
  TurmaID = null,
  DisciplinaID = null
) => {
  const api = createApiInstance();
  const { data } = await api.post("/allocation/remove", {
    teacherID,
    TurmaID,
    DisciplinaID,
  });
  return data;
};
export const deAllocateTeacher = async (teacherID, TurmaID, DisciplinaID) => {
  const api = createApiInstance();
  const { data } = await api.post("/allocation/remove", {
    teacherID,
    TurmaID,
    DisciplinaID,
  });
  return data;
};
export const getRoutinesByDate = async (date) => {
  const api = createApiInstance();
  const { data } = await api.post("/integrantes/date", { date });
  return data.integrantes;
};
export const deleteAnnouncements = async (announcementId) => {
  const api = createApiInstance();
  const { data } = await api.delete("/announcements/delete", {
    data: { id: announcementId },
  });
  return data;
};
export const setUserAccess = async (user) => {
  const api = createApiInstance();
  const { data } = await api.post("/access/new", user);
  return data;
};

export const resetUserPassword = async (userId, newPassword) => {
  const api = createApiInstance();
  const { data } = await api.post("/access/reset-password", {
    userId,
    newPassword,
  });
  return data;
};

export const deleteUser = async (userId) => {
  const api = createApiInstance();
  const { data } = await api.delete("/access/delete", {
    data: { userId },
  });
  return data;
};

export const updateAccessLevel = async (userId, name, login, level, allocations = null) => {
  const api = createApiInstance();
  const requestBody = {
    userId,
    name,
    login,
    level,
  };
  
  // Incluir allocations apenas se for professor
  if (level === "teacher") {
    requestBody.allocations = allocations;
  }
  
  const { data } = await api.put("/access/update", requestBody);
  return data;
};
export const sendDocuments = async (documents) => {
  const api = createApiInstance();
  const { data } = await api.post("/documents/upload", documents);
  return data;
};

export const getUsersByClass = async (classrooms) => {
  const api = createApiInstance();
  
  // Validação defensiva
  if (!classrooms || !Array.isArray(classrooms) || classrooms.length === 0) {
    throw new Error('classrooms deve ser um array não vazio');
  }
  
  // Normalizar classrooms para extrair apenas os IDs
  // Pode ser um array de objetos {TurmaID: ...} ou array de IDs (números/strings)
  const normalizedTurmaIds = classrooms
    .map((classroom) => {
      // Se for objeto, extrair TurmaID
      if (typeof classroom === 'object' && classroom !== null && classroom.hasOwnProperty('TurmaID')) {
        return classroom.TurmaID;
      }
      // Se já for um ID (número ou string numérica)
      return classroom;
    })
    .map((id) => {
      // Converter para número se for string numérica, ou manter número
      const numId = typeof id === 'string' ? parseInt(id, 10) : Number(id);
      return isNaN(numId) ? null : numId;
    })
    .filter((id) => id !== null && id > 0);
  
  // Validar se após normalização ainda temos IDs válidos
  if (normalizedTurmaIds.length === 0) {
    throw new Error('Nenhum ID de turma válido encontrado');
  }
  
  const { data } = await api.post("/announcements/users", {
    turmaIds: normalizedTurmaIds,
  });
  return data;
};

// Função auxiliar para obter o melhor valor entre MB, RM e RB
export const getBestGradeValue = (mb, rm, rb) => {
  // Converter valores para números (com tratamento para valores vazios/nulos)
  const mbValue = mb ? parseFloat(String(mb).replace(',', '.')) : 0;
  const rmValue = rm ? parseFloat(String(rm).replace(',', '.')) : 0;
  const rbValue = rb ? parseFloat(String(rb).replace(',', '.')) : 0;
  
  // Verificar se os valores são números válidos
  const validMB = !isNaN(mbValue) && mbValue > 0;
  const validRM = !isNaN(rmValue) && rmValue > 0;
  const validRB = !isNaN(rbValue) && rbValue > 0;
  
  let bestValue = validMB ? mbValue : 0;
  let source = validMB ? 'MB' : '';
  
  // Verificar se RM é melhor
  if (validRM && rmValue > bestValue) {
    bestValue = rmValue;
    source = 'RM';
  }
  
  // Verificar se RB é melhor
  if (validRB && rbValue > bestValue) {
    bestValue = rbValue;
    source = 'RB';
  }
  
  // Se não houver valor válido, retorna vazio
  if (bestValue === 0 || !source) {
    return { value: '', source: '' };
  }
  
  // Formatar o valor de volta para string com vírgula
  // Sempre exibe com uma casa decimal, mesmo para valores inteiros (ex: 10,0)
  const formattedValue = bestValue.toFixed(1).replace('.', ',');
  
  return {
    value: formattedValue,
    source,
    original: source === 'MB' ? formattedValue : mb
  };
};

// Nova função para indicar visualmente uma nota de recuperação
export const formatGradeWithRecoveryIndicator = (grade) => {
  if (!grade || !grade.used_recovery) return grade?.mb || '';
  
  // Adiciona um indicador visual que esta nota veio de recuperação
  return `${grade.mb}*`;
};

// Funções para consultar logs de alterações de notas
export const getGradeChangeLogs = async (filters = {}) => {
  const api = createApiInstance();
  const { data } = await api.post("/grades/logs", filters);
  return data;
};

export const getGradeChangeLogsResumo = async (filters = {}) => {
  const api = createApiInstance();
  const { data } = await api.post("/grades/logs/resumo", filters);
  return data;
};

export const getGradesByStudent = async (AlunoID, TurmaID) => {
  const api = createApiInstance();
  
  // Validações defensivas
  if (AlunoID === null || AlunoID === undefined || AlunoID === '') {
    throw new Error(`AlunoID inválido: ${AlunoID}`);
  }
  if (TurmaID === null || TurmaID === undefined || TurmaID === '') {
    throw new Error(`TurmaID inválido: ${TurmaID}`);
  }

  // Normalizar IDs para números inteiros positivos (backend espera números)
  const alunoIDNum = typeof AlunoID === 'string' ? parseInt(AlunoID, 10) : Number(AlunoID);
  const turmaIDNum = typeof TurmaID === 'string' ? parseInt(TurmaID, 10) : Number(TurmaID);
  
  // Validar se os números são válidos
  if (isNaN(alunoIDNum) || alunoIDNum <= 0) {
    throw new Error(`AlunoID inválido: ${AlunoID} (convertido para ${alunoIDNum})`);
  }
  if (isNaN(turmaIDNum) || turmaIDNum <= 0) {
    throw new Error(`TurmaID inválido: ${TurmaID} (convertido para ${turmaIDNum})`);
  }
  
  let data;
  try {
    const response = await api.post("/grades/boletim", { 
      AlunoID: alunoIDNum, 
      TurmaID: turmaIDNum 
    });
    data = response.data;
  } catch (error) {
    // Melhorar mensagem de erro
    if (error.response?.status === 400) {
      const errorMessage = error.response?.data?.message || error.message;
      throw new Error(`Erro de validação ao buscar boletim: ${errorMessage}`);
    }
    throw error;
  }
  
  // Processar cada período para comparar MB, RM e RB, usando o maior valor
  if (data) {
    ['period1', 'period2', 'period3', 'period4'].forEach(periodKey => {
      if (data[periodKey] && Array.isArray(data[periodKey])) {
        data[periodKey] = data[periodKey].map(grade => {
          // Se não tiver MB mas tiver AC1 e AC2, calcular MB 
          if (!grade.mb && grade.ac1 && grade.ac2) {
            const ac1Value = parseFloat(String(grade.ac1).replace(',', '.'));
            const ac2Value = parseFloat(String(grade.ac2).replace(',', '.'));
            if (!isNaN(ac1Value) && !isNaN(ac2Value)) {
              grade.mb = ((ac1Value + ac2Value) / 2).toFixed(1).replace('.', ',');
            }
          }
          
          // Formatar valores originais para garantir consistência
          grade.at1 = formatNotaParaExibicao(grade.at1);
          grade.at2 = formatNotaParaExibicao(grade.at2);
          grade.at3 = formatNotaParaExibicao(grade.at3);
          grade.at4 = formatNotaParaExibicao(grade.at4);
          grade.at5 = formatNotaParaExibicao(grade.at5);
          grade.at6 = formatNotaParaExibicao(grade.at6);
          grade.ac1 = formatNotaParaExibicao(grade.ac1);
          grade.ac2 = formatNotaParaExibicao(grade.ac2);
          
          // Obter o melhor valor entre MB, RM e RB
          const bestGrade = getBestGradeValue(grade.mb, grade.rm, grade.rb);
          
          // Se o melhor valor não for MB (ou seja, for RM ou RB), substituir
          if (bestGrade.source && bestGrade.source !== 'MB') {
            // Guardar o valor original e atualizar para o melhor valor
            grade.mb_original = grade.mb || '';
            grade.mb = bestGrade.value; // bestGrade.value já está formatado corretamente
            grade.used_recovery = true;
            grade.recovery_source = bestGrade.source;
          } else {
            // Garantir que MB também esteja formatado consistentemente, mesmo quando não for substituído
            grade.mb = formatNotaParaExibicao(grade.mb);
          }
          
          // Formatar RM e RB para exibição consistente
          grade.rm = formatNotaParaExibicao(grade.rm);
          grade.rb = formatNotaParaExibicao(grade.rb);
          
          return grade;
        });
      }
    });
  }
  
  return data;
};

export const saveFinalResults = async (AlunoID, TurmaID, grades) => {
  const api = createApiInstance();
  
  // Garantir que todos os disciplinaId sejam números inteiros
  const normalizedGrades = grades.map(grade => {
    const disciplinaIdNum = typeof grade.disciplinaId === 'string' 
      ? parseInt(grade.disciplinaId, 10) 
      : Number(grade.disciplinaId);
    
    // Validar se o número é válido
    if (isNaN(disciplinaIdNum) || disciplinaIdNum <= 0) {
      throw new Error(`disciplinaId inválido: ${grade.disciplinaId}`);
    }
    
    return {
      ...grade,
      disciplinaId: disciplinaIdNum,
    };
  });
  
  // Garantir que AlunoID e TurmaID sejam números
  const alunoIDNum = typeof AlunoID === 'string' ? parseInt(AlunoID, 10) : Number(AlunoID);
  const turmaIDNum = typeof TurmaID === 'string' ? parseInt(TurmaID, 10) : Number(TurmaID);
  
  // Validar se os números são válidos
  if (isNaN(alunoIDNum) || alunoIDNum <= 0) {
    throw new Error(`AlunoID inválido: ${AlunoID}`);
  }
  if (isNaN(turmaIDNum) || turmaIDNum <= 0) {
    throw new Error(`TurmaID inválido: ${TurmaID}`);
  }
  
  const { data } = await api.post("/grades/final/add", {
    AlunoID: alunoIDNum,
    TurmaID: turmaIDNum,
    grades: normalizedGrades,
  });
  return data;
};

export const getFinalResults = async (AlunoID, TurmaID) => {
  const api = createApiInstance();
  
  // Validações defensivas
  if (AlunoID === null || AlunoID === undefined || AlunoID === '') {
    throw new Error(`AlunoID inválido: ${AlunoID}`);
  }
  if (TurmaID === null || TurmaID === undefined || TurmaID === '') {
    throw new Error(`TurmaID inválido: ${TurmaID}`);
  }

  // Normalizar IDs para números inteiros positivos (backend espera números)
  const alunoIDNum = typeof AlunoID === 'string' ? parseInt(AlunoID, 10) : Number(AlunoID);
  const turmaIDNum = typeof TurmaID === 'string' ? parseInt(TurmaID, 10) : Number(TurmaID);
  
  // Validar se os números são válidos
  if (isNaN(alunoIDNum) || alunoIDNum <= 0) {
    throw new Error(`AlunoID inválido: ${AlunoID} (convertido para ${alunoIDNum})`);
  }
  if (isNaN(turmaIDNum) || turmaIDNum <= 0) {
    throw new Error(`TurmaID inválido: ${TurmaID} (convertido para ${turmaIDNum})`);
  }
  
  try {
    const response = await api.post("/grades/final/list", { 
      AlunoID: alunoIDNum, 
      TurmaID: turmaIDNum 
    });
    return response.data;
  } catch (error) {
    // Melhorar mensagem de erro
    if (error.response?.status === 400) {
      const errorMessage = error.response?.data?.message || error.message;
      throw new Error(`Erro de validação ao buscar resultados finais: ${errorMessage}`);
    }
    throw error;
  }
};

// Nova função para sincronizar notas pendentes
export const syncPendingGrades = async () => {
  // Lista para armazenar promessas de sincronização
  const syncPromises = [];
  
  // Encontrar todas as chaves de sincronização no localStorage
  const syncKeys = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && key.startsWith('grade_sync_')) {
      syncKeys.push(key);
    }
  }
  
  // Processar cada entrada pendente
  for (const key of syncKeys) {
    try {
      const syncDataString = localStorage.getItem(key);
      if (!syncDataString) continue;
      
      const syncData = JSON.parse(syncDataString);
      const { alunoID, updatedFields, timestamp, period } = syncData;
      
      // Verificar se os dados são recentes (menos de 7 dias)
      const dataTime = new Date(timestamp).getTime();
      const now = new Date().getTime();
      const maxAge = 7 * 24 * 60 * 60 * 1000; // 7 dias em milissegundos
      
      if (now - dataTime > maxAge) {
        localStorage.removeItem(key);
        continue;
      }
      
      // Extrair TurmaID e DisciplinaID do key
      const parts = key.split('_');
      if (parts.length < 6) {
        localStorage.removeItem(key);
        continue;
      }
      
      const turmaID = parts[3];
      const disciplinaID = parts[4];
      const keyPeriod = parts[5];
      
      // Garantir que o período na chave corresponde ao período nos dados
      if (keyPeriod !== String(period)) {
        // Atualizar o período nos dados para corresponder à chave
        updatedFields.period = keyPeriod;
      }
      
      // Calcular AC1 e AC2 localmente antes de enviar
      const at1Value = parseFloat((updatedFields.at1 && updatedFields.at1.replace(",", ".")) || 0);
      const at2Value = parseFloat((updatedFields.at2 && updatedFields.at2.replace(",", ".")) || 0);
      const at3Value = parseFloat((updatedFields.at3 && updatedFields.at3.replace(",", ".")) || 0);
      const at4Value = parseFloat((updatedFields.at4 && updatedFields.at4.replace(",", ".")) || 0);
      const at5Value = parseFloat((updatedFields.at5 && updatedFields.at5.replace(",", ".")) || 0);
      const at6Value = parseFloat((updatedFields.at6 && updatedFields.at6.replace(",", ".")) || 0);
      
      // Calcular AC1 (soma de AT1 e AT2)
      let ac1 = "";
      if (at1Value > 0 || at2Value > 0) {
        ac1 = (at1Value + at2Value).toFixed(1).replace(".", ",");
      }
      
      // Calcular AC2 (soma de AT3, AT4, AT5 e AT6)
      let ac2 = "";
      if (at3Value > 0 || at4Value > 0 || at5Value > 0 || at6Value > 0) {
        ac2 = (at3Value + at4Value + at5Value + at6Value).toFixed(1).replace(".", ",");
      }
      
      // Calcular MB (média de AC1 e AC2)
      let mb = "";
      if (ac1 || ac2) {
        const ac1Value = parseFloat((ac1 && ac1.replace(",", ".")) || 0);
        const ac2Value = parseFloat((ac2 && ac2.replace(",", ".")) || 0);
        
        if (ac1Value > 0 || ac2Value > 0) {
          mb = ((ac1Value + ac2Value) / 2).toFixed(1).replace(".", ",");
        }
      }
      
      // Adicionar os campos calculados aos dados a serem enviados
      const dataToSync = {
        ...updatedFields,
        ac1,
        ac2,
        mb
      };
      
      // Adicionar à fila de sincronização
      const syncPromise = updateGradesByStudent(
        alunoID,
        turmaID,
        disciplinaID,
        period,
        dataToSync.at1 === "0" ? "" : dataToSync.at1,
        dataToSync.at2 === "0" ? "" : dataToSync.at2,
        dataToSync.at3 === "0" ? "" : dataToSync.at3,
        dataToSync.at4 === "0" ? "" : dataToSync.at4,
        dataToSync.at5 === "0" ? "" : dataToSync.at5,
        dataToSync.at6 === "0" ? "" : dataToSync.at6,
        dataToSync.ac1 === "0" ? "" : dataToSync.ac1,
        dataToSync.ac2 === "0" ? "" : dataToSync.ac2,
        dataToSync.rm === "0" ? "" : dataToSync.rm,
        dataToSync.mb === "0" ? "" : dataToSync.mb,
        "", // nomeDisciplina - não necessário para sincronização
        dataToSync.visibility
      )
      .then(() => {
        localStorage.removeItem(key);
        return { success: true, key };
      })
      .catch(error => {
        // Atualizar o timestamp para tentar novamente mais tarde
        const updatedSyncData = {
          ...syncData,
          timestamp: new Date().toISOString(),
          retryCount: (syncData.retryCount || 0) + 1
        };
        
        // Se já tentamos muitas vezes, marcar como problemático
        if (updatedSyncData.retryCount > 5) {
          updatedSyncData.problematic = true;
        }
        
        localStorage.setItem(key, JSON.stringify(updatedSyncData));
        return { success: false, key, error };
      });
      
      syncPromises.push(syncPromise);
    } catch (error) {
      // Erro ao processar item de sincronização
    }
  }
  
  // Aguardar todas as sincronizações
  const results = await Promise.allSettled(syncPromises);
  
  // Analisar resultados
  const successful = results.filter(r => r.status === 'fulfilled' && r.value.success).length;
  const failed = results.filter(r => r.status === 'fulfilled' && !r.value.success).length;
  const errors = results.filter(r => r.status === 'rejected').length;
  
  return {
    successful,
    failed,
    errors,
    total: syncPromises.length
  };
};

// Nova função para limpar dados de localStorage inconsistentes
export const cleanupLocalStorage = () => {
  // Contadores para estatísticas
  let removed = 0;
  let kept = 0;
  
  // Obter todas as chaves no localStorage relacionadas a notas
  const allKeys = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && (key.startsWith('grade_sync_') || key.startsWith('visibility_'))) {
      allKeys.push(key);
    }
    // Remover backups antigos se existirem
    if (key && key.startsWith('grade_backup_')) {
      localStorage.removeItem(key);
      removed++;
    }
  }
  
  // Para cada chave, verificar sua integridade e validade
  for (const key of allKeys) {
    try {
      const dataString = localStorage.getItem(key);
      if (!dataString) {
        localStorage.removeItem(key);
        removed++;
        continue;
      }
      
      const data = JSON.parse(dataString);
      
      // Verificar timestamp
      const timestamp = data.timestamp;
      if (!timestamp) {
        // Silenciosamente remover dados sem timestamp (sem warning)
        localStorage.removeItem(key);
        removed++;
        continue;
      }
      
      // Verificar se os dados são muito antigos (mais de 14 dias)
      const dataTime = new Date(timestamp).getTime();
      const now = new Date().getTime();
      const maxAge = 14 * 24 * 60 * 60 * 1000; // 14 dias em milissegundos
      
      if (now - dataTime > maxAge) {
        localStorage.removeItem(key);
        removed++;
        continue;
      }
      
      // Se chegou aqui, os dados são válidos
      kept++;
      
    } catch (error) {
      localStorage.removeItem(key);
      removed++;
    }
  }
  
  return { removed, kept };
};

// Função para formatar e exibir notas de forma padronizada (com indicador de recuperação)
export const formatNotaParaExibicao = (valor, recovery = false) => {
  if (valor === null || valor === undefined || valor === "" || valor === "0") {
    return "";
  }
  
  try {
    // Normalizar para número para garantir formatação consistente
    const valorNumerico = parseFloat(String(valor).replace(",", "."));
    
    // Verificar se é um número válido
    if (isNaN(valorNumerico) || valorNumerico === 0) {
      return "";
    }
    
    // Formatar sempre com uma casa decimal, sem arredondamento para cima
    // Usar toFixed(1) garante a mesma precisão que o sistema Sponte
    const notaFormatada = valorNumerico.toFixed(1).replace(".", ",");
    
    // Adicionar o indicador de recuperação se necessário
    return recovery ? `${notaFormatada}*` : notaFormatada;
  } catch (error) {
    console.error("Erro ao formatar nota:", error);
    return String(valor);
  }
};

// Função para formatar valores para envio ao Sponte
// Garante sempre 1 casa decimal, sem arredondamento automático
export const formatSponteValue = (valor) => {
  if (valor === null || valor === undefined || valor === "" || valor === "0") {
    return "";
  }
  
  try {
    // Normalizar valor para número para garantir formato correto
    const numValue = parseFloat(String(valor).replace(",", "."));
    
    // Verificar se é um número válido
    if (isNaN(numValue) || numValue === 0) {
      return "";
    }
    
    // CRÍTICO: Aplicar arredondamento matemático explícito para uma casa decimal
    // Math.round((x) * 10) / 10 garante arredondamento matemático correto
    // Exemplo: 6.35 → 6.4, 6.34 → 6.3
    const roundedValue = Math.round(numValue * 10) / 10;
    
    // Formatar com exatamente 1 casa decimal e usar vírgula como separador
    // toFixed(1) garante sempre uma casa decimal, mesmo para números inteiros (ex: 6 → 6,0)
    return roundedValue.toFixed(1).replace(".", ",");
  } catch (error) {
    return String(valor); // Retornar o valor original em caso de erro
  }
};

// ==================== API de Cardápio ====================

/**
 * Busca o cardápio de uma unidade
 * @param {string} unit - Unidade (CAMPINA GRANDE ou PATOS)
 * @returns {Promise<Object>} Cardápio com estrutura { breakfast: [], lunch: [], snack: [] }
 */
export const getMenu = async (unit) => {
  const api = createApiInstance();
  const { data } = await api.get(`/menu/${unit}`);
  return data;
};

/**
 * Salva o cardápio completo de uma unidade
 * @param {string} unit - Unidade
 * @param {Object} menu - Objeto com estrutura { breakfast: [], lunch: [], snack: [] }
 * @returns {Promise<Object>} Cardápio salvo
 */
export const saveMenu = async (unit, menu) => {
  const api = createApiInstance();
  const { data } = await api.post("/menu/save", { unit, menu });
  return data;
};

/**
 * Adiciona um item ao cardápio
 * @param {string} unit - Unidade
 * @param {string} mealType - Tipo de refeição (breakfast, lunch, snack)
 * @param {string} name - Nome do item
 * @returns {Promise<Object>} Item criado
 */
export const addMenuItem = async (unit, mealType, name) => {
  const api = createApiInstance();
  const { data } = await api.post("/menu/item", { unit, mealType, name });
  return data;
};

/**
 * Remove um item do cardápio
 * @param {number} id - ID do item
 * @returns {Promise<Object>} Resultado da remoção
 */
export const removeMenuItem = async (id) => {
  const api = createApiInstance();
  const { data } = await api.delete(`/menu/item/${id}`);
  return data;
};

/**
 * Atualiza um item do cardápio
 * @param {number} id - ID do item
 * @param {Object} updateData - Dados para atualizar
 * @returns {Promise<Object>} Item atualizado
 */
export const updateMenuItem = async (id, updateData) => {
  const api = createApiInstance();
  const { data } = await api.put(`/menu/item/${id}`, updateData);
  return data;
};
